import { CloseCircleFilled, ExclamationCircleFilled, InfoCircleTwoTone, SearchOutlined, SettingOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Cascader as Cascaded,
  Radio,
  Row,
  Select,
  Space,
  Rate,
  Dropdown,
  Menu,
  DatePicker,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { OptGroup } from 'rc-select'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Gender, getGenderName, StationCategory } from '../../../../models/user'
import { ThemeContext } from '../../../../theme/ThemeContext'
import {
  phonePatterns,
} from '../../../../utils/RegExp'
import { getAge } from '../../../../utils/StringUtils'
import styles from './dentureLedgerPage.module.css'
import { RootDispatch } from '../../../../app/store'
import { getPatientList, selectPatients } from '../../../registration/register/registerSlice'
import { ToothComponents } from '../../../treatment/editor/modals/toothComponents'
import { DateTimeFormatSimple, DateTimeFormatSimpleOnlyOne } from '../../../../models/datetime'
import { getUsersInDepartmentAsync } from '../../../completion/completionSlice'
import { RelevancyoOutsideProcessingModal } from './asssociatedOutsourcingProcessingModal'
import { getDentalLedgerSubmitAsync, getDoctorAuditEntriesDetailAsync } from './dentureLedgerSlice'
import { selectStationCategory, selectUserId } from '../../../../app/applicationSlice'
import { getMaskPhone } from '../../../../models/phone'

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 17 },
}

interface AddOrEditFalseToothModalProps {
  SYCKHRSJHData?:boolean
  id?: any
  visible: boolean
  onOk: (num?: number, obj?: string, cardType?: any) => void
  onCancel: () => void
}

export const AddOrEditFalseToothModal = ({
  SYCKHRSJHData,
  id,
  visible,
  onOk,
  onCancel,
}: AddOrEditFalseToothModalProps) => {
  const theme = useContext(ThemeContext)

  const [isPatientOverlayVisible, setIsPatientOverlayVisible] = useState(false) //患者姓名输入框下拉查询弹窗

  const [confirmLoading, setConfirmLoading] = useState(false) //确认按钮loading

  const [isModalVisible, setIsModalVisible] = useState(false) //关联外处理弹窗

  const userId = useSelector(selectUserId)

  const stationCategory = useSelector(selectStationCategory)

  const dispatch = useDispatch<RootDispatch>()

  const patients: any = useSelector(selectPatients)

  const [keyword, setKeyword] = useState('') //患者姓名输入框

  const [patientId, setPatientId] = useState('') //患者id

  const [disabled, setDisabled] = useState(false)

  const [detail, setDetail] = useState<any>({}) //详情数据

  const [form] = Form.useForm()

  const [doctorList, setDoctorList] = useState<any>([]) //医生数据

  const [phoneInfo, setPhoneInfo] = useState<any>({}) //患者手机号

  useEffect(() => {
    getDoctorList()
  }, [])

  const getDoctorList = () => {
    //获取医生
    dispatch(
      getUsersInDepartmentAsync({
        departmentId: '',
        stationCategory: StationCategory.DoctorOrPharmacist,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setDoctorList(res)
      })
  }

  const patientOverlay = (
    <Menu className={styles.patientOverlay}>
      {patients?.map(
        (p: any) => (
          <Menu.Item
            key={p.id}
            onClick={() => {
              setKeyword(p.name)
              setPatientId(p.id)
              setDisabled(true)
              setPhoneInfo({
                phoneNumber: p.phone,
                phoneDisabled: p?.phone && !SYCKHRSJHData,
              })
              form.setFieldsValue({
                placeholderAge: '  ', //年龄占位
                patientId: p.id,
                patientName: p.name,
                sex: String(p.sex),
                ageYear: p.ageYear,
                ageMonth: p.ageMonth,
                phoneNumber: p.phone ? (!SYCKHRSJHData ? getMaskPhone(p.phone) : p.phone) : '',
              })
              if (p?.birthday) {
                updateYearsAndMonths(p?.birthday)
              }
              setIsPatientOverlayVisible(false)
            }}
          >

            <Space>
              <span>{p.name}</span>
              <span>{getGenderName(p.sex)}</span>
              <span>{getAge(p.ageYear, p.ageMonth, '岁')}</span>
              <span>{p.phone ? (!SYCKHRSJHData ? getMaskPhone(p.phone) : p.phone) : ''}</span>
              <span>{p.tenantPatientCardId}</span>
            </Space>
          </Menu.Item>
        )
      )}
    </Menu>
  )

  const updateBirthday = () => {
    const year = parseInt(form.getFieldValue('ageYear')) || 0
    const month = parseInt(form.getFieldValue('ageMonth')) || 0
    if (year !== 0 || month !== 0) {
      const months = year * 12 + month
      const birthday = moment().subtract(months, 'months').format('YYYY/MM/DD')
      form.setFieldsValue({ birthday })
    }
  }

  const updateYearsAndMonths = (brdy?: any) => {
    let date
    if (!brdy) {
      date = moment(form.getFieldValue('birthday'))
    } else {
      date = moment(brdy)
    }
    if (!date.isValid()) {
      return
    }
    const duration = moment.duration(moment().diff(date))
    if (duration.years() < 0 || duration.months() < 0) {
      return
    }

    form.setFieldsValue({
      ageYear: duration.years(),
      ageMonth: duration.months() == 0 ? 1 : duration.months(),
    })
    const year = duration.years()
    const month = duration.months() == 0 ? 1 : duration.months()
    if (year !== 0 || month !== 0) {
      if (brdy) {
        const months = year * 12 + month
        const birthday = moment()
          .subtract(months, 'months')
          .format('YYYY/MM/DD')
        form.setFieldsValue({ birthday })
        form.setFieldsValue({ placeholderAge: '1111' })
      }
    }
  }

  useEffect(() => {
    dispatch(getPatientList(keyword))
  }, [dispatch, keyword])

  const resetData = () => {
    form.resetFields()
    setDisabled(false)
    setPatientId('')
    setKeyword('')
    setDetail({})
    setPhoneInfo({})
  }

  useEffect(() => {
    if (visible) {
      if (stationCategory == StationCategory.DoctorOrPharmacist) {
        form.setFieldsValue({
          doctorId: userId?.toString(),
        })
      }
    }
  }, [stationCategory, userId, visible])

  useEffect(() => {
    if (visible) {
      if (id) {
        dispatch(getDoctorAuditEntriesDetailAsync({ id: id }))
          .then(unwrapResult)
          .then((res: any) => {
            setMessage(res)
          })
      } else {
        form.setFieldsValue({
          sex: '0'
        })
      }
    } else {
      resetData()
    }
  }, [visible, id])


  const setMessage = (res: any) => {
    setDetail(res)
    setDisabled(true)
    setPatientId(res.patientId || '')
    setKeyword(res.patientName)
    setPhoneInfo({
      phoneNumber: res.phoneNumber,
      phoneDisabled: res.phoneNumber && !SYCKHRSJHData,
    })
    const flag = doctorList.find((v: any) => v.id == form.getFieldValue('doctorId')?.toString())
    form.setFieldsValue({
      ...res,
      phoneNumber: res?.phoneNumber ? (!SYCKHRSJHData ? getMaskPhone(res.phoneNumber) : res.phoneNumber) : '',
      ageMonth: res.ageMonth != -1 ? res.ageMonth : 0,
      doctorId: flag ? form.getFieldValue('doctorId')?.toString() : '',
      processProvider: res.productionUnit || '',
      processStartTime: res.customDate ? moment(res.customDate) : undefined,
      processItemDisease: res.variety  + ( res?.processItemColorNo ? '（' + res?.processItemColorNo + '）' : ''),
      orderNo: res.customOrderNo || '',
    })
    if (res?.birthday) {
      updateYearsAndMonths(res?.birthday)
    }
  }

  return (
    <>
      <Modal
        title={id ? '编辑义齿使用' : '新增义齿使用'}
        width={1000}
        visible={visible}
        confirmLoading={confirmLoading}
        onCancel={() => {
          onCancel()
          resetData()
        }}
        onOk={() => {
          form.submit()
        }}
        className={styles.addPatientModal}
        maskClosable={false}
        destroyOnClose
        centered
      >
        <Form
          form={form}
          {...layout}
          style={{ paddingRight: 10 }}
          onFinish={(values) => {
            setConfirmLoading(true)
            const processItemTooth = values.processItemTooth.map((el: any) => (el ? el : '--')).join('@')

            const doctorName = doctorList?.find((el: any) => el.id == values.doctorId)?.name
            const submitParams = {
              ...values,
              phoneNumber: values?.phoneNumber == getMaskPhone(values?.phoneNumber) ? phoneInfo?.phoneNumber : values?.phoneNumber || '',
              patientId: patientId,
              doctorName,
              processItemTooth,
              id: id ? id : undefined,
              processStartTime: values.processStartTime ? moment(values.processStartTime).format(DateTimeFormatSimpleOnlyOne) : undefined
            }
            dispatch(
              getDentalLedgerSubmitAsync(submitParams)
            )
              .then(unwrapResult)
              .then((v) => {
                notification.success({
                  message: '操作成功',
                })
                onOk()
                resetData()
              })
              .finally(() => {
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                name='patientName'
                label={'患者姓名'}
                rules={[{ required: true }]}
              >
                <Dropdown
                  overlay={patientOverlay}
                  visible={isPatientOverlayVisible}
                  disabled={disabled}
                >
                  <Input
                    style={{ width: '100%' }}
                    allowClear
                    placeholder={'患者姓名/助记码/手机号/病历号'}
                    prefix={
                      <SearchOutlined style={{ color: theme.tc3 }} />
                    }
                    value={keyword}
                    onFocus={() => {
                      dispatch(getPatientList(keyword))
                      setIsPatientOverlayVisible(true)
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        setIsPatientOverlayVisible(false)
                      }, 300)
                    }}
                    onClick={() => {
                      setIsPatientOverlayVisible(true)
                    }}
                    onChange={(e) => {
                      form.setFieldsValue({
                        name: e.target.value,
                      })
                      setIsPatientOverlayVisible(true)
                      setKeyword(e.target.value)
                    }}
                  />
                </Dropdown>
              </Form.Item>
              {id ? ' ' : <div style={{ position: 'absolute', top: '0px', right: '-20px', zIndex: 9999 }}>
                <Button type='link' onClick={() => {
                  form.setFieldsValue({
                    patientName: '',
                    sex: '',
                    ageYear: '',
                    ageMonth: '',
                    birthday: '',
                    phoneNumber: '',
                  })
                  setKeyword('')
                  setDisabled(false)
                  setPhoneInfo({})
                }}>清空</Button>
              </div>}

            </Col>
            <Col span={12}>
              <Form.Item
                name='sex'
                label='性别'
                rules={[{ required: true }]}
              >
                <Radio.Group disabled={disabled}>
                  <Radio value='1'>男</Radio>
                  <Radio value='2'>女</Radio>
                  <Radio value='0'>未知</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12} className={styles.birthdayStyle}
            >
              <Form.Item
                label='年龄'
                name='placeholderAge'
                rules={[{ required: true, message: '' }]}
              >
                <Row
                  wrap={false}
                  align='middle'
                  style={{ marginTop: '-6px' }}
                >
                  <Form.Item
                    name='ageYear'
                    noStyle
                    dependencies={['ageMonth']}
                    rules={[
                      {
                        pattern: /^\d{0,3}$/,
                        message: '请输入正确的年龄',
                      },
                      ({ getFieldValue }) => ({
                        validator: (_, value) => {
                          if (!value && !getFieldValue('ageMonth')) {
                            return Promise.reject(
                              new Error('请输入正确的年龄')
                            )
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                  >
                    <Input
                      disabled={disabled}
                      onChange={updateBirthday}
                      style={{ maxWidth: '4rem' }}
                    />
                  </Form.Item>
                  <div
                    style={{
                      color: theme.tc2,
                      fontSize: '1rem',
                      margin: '0 6px',
                    }}
                  >
                    岁
                  </div>
                  <Form.Item
                    name='ageMonth'
                    noStyle
                    dependencies={['ageYear']}
                    rules={[
                      {
                        pattern: /^(0?[0-9]|1[0-1])$/,
                        message: '请输入正确的月份',
                      },
                    ]}
                  >
                    <Input
                      disabled={disabled}
                      onChange={updateBirthday}
                      style={{ maxWidth: '4rem' }}
                    />
                  </Form.Item>
                  <div
                    style={{
                      color: theme.tc2,
                      fontSize: '1rem',
                      margin: '0 6px',
                    }}
                  >
                    月
                  </div>
                  <Form.Item
                    name='birthday'
                    noStyle
                    style={{ flex: 1 }}
                    rules={[
                      { max: 10, message: '最多10个字' },
                      {
                        pattern: /^(?:1\d{3}|2\d{3})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})\/(?:0[1-9]|1[0-2])\/(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])$/,
                        message: '格式参考:19950816',
                      },
                    ]}
                  >
                    <Input
                      disabled={disabled}
                      onChange={() => updateYearsAndMonths()}
                      style={{ width: "150px" }}
                    />
                  </Form.Item>
                </Row>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='phoneNumber'
                label='联系方式'
                rules={[
                  phoneInfo?.phoneDisabled ? {} : { ...phonePatterns },
                ]}
              >
                <Input
                  allowClear
                  maxLength={13}
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12} style={{ position: 'relative' }}>
              <Form.Item
                name='processItemDisease'
                label='义齿品种'
                rules={[{ required: true }]}
              >
                <Input allowClear maxLength={30} />
              </Form.Item>
              <div style={{ position: 'absolute', top: '0px', right: '-80px', }}>
                <Button type="primary"
                  ghost
                  onClick={() => {
                    setIsModalVisible(true)
                  }}>
                  关联外加工
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                name='processItemTooth'
                label='牙位'
              >
                <ToothComponents
                  isShowSave={false}
                  isEdit={true}
                  data={detail?.toothPosition || '--@--@--@--'}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                name='processProvider'
                label='生产单位'
              >
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='registrationCertificateNo'
                label='注册证号'
              >
                <Input allowClear />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                name='orderNo'
                label='定制单编号'
              >
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='processStartTime'
                label='定制日期'
              >
                <DatePicker
                  format={DateTimeFormatSimple}
                  allowClear
                  style={{ width: "100%" }} />
              </Form.Item>
            </Col>

          </Row>
          <Row>
            <Col span={12}>
              <Form.Item name='doctorId' label='医生'>
                <Select
                  placeholder='医生'
                  style={{ width: '100%' }}
                  allowClear
                  showSearch
                  filterOption={(input, option: any) =>
                    (option?.children ?? '')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {doctorList.map((v: any) => (
                    <Select.Option key={v.id} value={v.id}>
                      {v.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <RelevancyoOutsideProcessingModal
        keyWord={keyword}
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        relevancyChange={(t) => {
          setIsModalVisible(false)
          setMessage(t)
          // dispatch(getDentalLedgerProcessDetailAsync({ processItemId: t?.processItemId }))
          //   .then(unwrapResult)
          //   .then((res?: any) => {
          //     setMessage(res)
          //   })
        }}
      />
    </>
  )
}
